/* @flow */

import actionTypes from './types';
import actionFactory from './actionsFactory/types';

const {
  SET_SELECTED_PAIR, SET_SELECTED_ASSET_TAB, SET_SELECTED_STABLE_COIN_TABS,
} = actionTypes;
const { SET_IS_MARGIN_PAIR } = actionFactory;

// eslint-disable-next-line import/prefer-default-export
export const setSelectedPair = (selectedPair: string) => (dispatch: Function) => dispatch({
  type: SET_SELECTED_PAIR, data: selectedPair,
});

// eslint-disable-next-line import/prefer-default-export
export const setSelectedAssetTab = (selectedAssetTab: string) => (dispatch: Function) => dispatch({
  type: SET_SELECTED_ASSET_TAB, data: selectedAssetTab,
});

// eslint-disable-next-line import/prefer-default-export
export const setSelectedStableCoinTabs = (selectedStableCoinTabs: Object) => (
  (dispatch: Function) => (
    dispatch({ type: SET_SELECTED_STABLE_COIN_TABS, data: selectedStableCoinTabs })
  ));

// eslint-disable-next-line import/prefer-default-export
export const setIsMarginPair = (data: boolean) => (dispatch: Function) => dispatch({
  type: SET_IS_MARGIN_PAIR, data,
});
